import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Logout from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { BsFillPersonFill } from "react-icons/bs";
import { getAuth, signOut } from "firebase/auth";
import app from '../auth/firebase.init';
import { toast } from 'react-toastify';
import { logOutUser } from '../../features/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';


export default function AccountMenu({ mdmain, userInfo }) {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const auth = getAuth(app);
    const handlesignOut = () => {
        signOut(auth).then(() => {
            // Sign-out successful.
            toast.success("Sign-out successful", {
                position: "bottom-left",
            });
            dispatch(logOutUser());
        }).catch((error) => {
            // An error happened.
            toast.error("An error happened.", {
                position: "bottom-left",
            });
        });
    }

    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = React.useState(true);

    React.useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                {/* <Tooltip title="Account settings"> */}
                <Box
                    onClick={handleClick}
                    size="small"
                    // sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    // className="bg-green-500 p-5"
                >
                    {/* <Avatar sx={{ width: 32, height: 32 }}>M</Avatar> */}

                    <div>
                        {mdmain ?
                            <p className='h-full text-2xl'>
                                <BsFillPersonFill className='text-gray-600' />
                            </p> :
                            <p className='focus:outline-none md:text-bnd-1 px-3 flex gap-1'>
                                {/* <Link className='hover:text-inherit' to="/profile"> */}

                                {userInfo?.displayName ? userInfo?.displayName.toUpperCase() + "'S ACCOUNT" : "profile"}
                            </p>
                        }
                    </div>
                </Box>
                {/* </Tooltip> */}

            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {/* <MenuItem>
                    <Avatar /> Profile
                </MenuItem>
                <MenuItem>
                    <Avatar /> My account
                </MenuItem> */}
                {/* <Divider /> */}
                {/* <MenuItem>
                    <ListItemIcon>
                        <PersonAdd fontSize="small" />
                    </ListItemIcon>
                    Add another account
                </MenuItem> */}
                <Link to="/user" className='hover:no-underline hover:text-inherit'>
                    <MenuItem>
                        <ListItemIcon>
                            <ShoppingBagIcon fontSize="small" />
                        </ListItemIcon>
                        {translate ? "My Orders" : "আমার অডার গুলো"}
                    </MenuItem>
                </Link>
                <Divider />
                <MenuItem onClick={handlesignOut}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    {translate ? "Logout" : "লগ আউট"}
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}